import { mainActionTypes }  from '../settings/types'

const initialState = {
    userIsAdmin: false,
    loading: false,
    viewMode : 'LIST',
    app : {},
    udn : {},
    category : null,
}

const mainReducer = (state = initialState, action) => {
    switch (action.type) {
        case mainActionTypes.clearState:
            return initialState
        case mainActionTypes.loading:
            return {
                ...state,
                loading: action.payload
            }
        case mainActionTypes.view:
            return {
                ...state,
                viewMode: action.payload
            }
        case mainActionTypes.menu:
            return {
                ...state,
                menu: action.payload
            }
        case mainActionTypes.module:
            return {
                ...state,
                module: action.payload
            }
        case mainActionTypes.app:
            return {
                ...state,
                app: action.payload
            }
        case mainActionTypes.udn:
            return {
                ...state,
                udn: action.payload
            }
        case mainActionTypes.parent:
            return {
                ...state,
                parent: action.payload
            }
        case mainActionTypes.mapConfig:
            return {
                ...state,
                mapConfig: action.payload
            }
        case mainActionTypes.category:
            return {
                ...state,
                category: action.payload
            }
        case mainActionTypes.userIsAdmin:
            return {
                ...state,
                userIsAdmin: action.payload
            }
        default:
            return state
    }
}

export default mainReducer